// @flow
import React from "react";
import Logo from "./Logo";

import logo from "./logo.png";
import logoMobile from "./logo-small.png";
import errorBg from "./error-bg.png";
import indexLogo from "./new-index-logo.svg";
import indexLogoText from "./new-indexLogo-text.svg";
import indexHeaderBackground from "./header-iron.jpg";
import refLogo from "../../components/Regbonus/images/ref_img/logo.png";
import refLogoText from "../../components/Regbonus/images/ref_img/logo-text.png";
import howToBackground from "../../images/howto-bg-iron.jpg";
import desktopTourBgDark from "../../images/desktop-tour-bg-dark.jpg";
import desktopTourBgLight from "../../images/desktop-tour-bg-light.jpg";

import { IronTradeFlat as ReLogo } from "../../components/Icons/Index/index";

import { rgba } from "polished";
import basicSiam from "../siamoption/siamoption";

const basic = {
  direction: "ltr",
  // основной шрифт
  fontFamily: "Roboto, Arial, sans-serif",
  // логотип
  logo: <Logo />,
  logoImg: logo,
  logoImgMobile: logoMobile,
  errorBg: errorBg,

  // ЦВЕТА
  // основной цвет
  main: "#272B34",
  mainDark: "#1D2027", // шапка
  mainLight: "#272B34", // сайдбар
  mainHighlight: "#272B34",
  mainFontColor: "#38465d",
  mainSeparator: "#393939",

  newIndex: true,
  mode: "dark",
  foreground: "#ffffff",
  alternativeForeground: "#ffffff",
  lightWhiteForeground: "#ffffff",
  background: "#000",
  mainColorBackground: "#272B34",
  secondaryColorBackground: "#272B34",

  ticksFontColor: "#8d8d8d",
  ticksBorderColor: "#4e4e4e",
  borderMainColor: "#555555",

  accent: "#feac00",
  alternativeAccent: "#feac00",
  lightAccent: "#ffcc00",
  lightWhiteAccent: "#feac00",
  accentOpacity: "rgba(254, 172, 0, .5)",
  secondaryTextColor: "#99959d",

  upper: "#3B9478", // positive ставки
  alternativeUpper: "#60a31c",
  upperAccent: "#48AE7E",
  upperBorder: "#2E735D",
  upperBoxShadow: "#48AE7E",

  lower: "#D05353", // negative ставки
  lowerAccent: "#EE7F7F",
  lowerBorder: "#A34141",
  lowerBoxShadow: "#EE7F7F",

  // анимации для попапов
  perspective: "1300px",
  showAnimation: ".15s linear 1",

  // цвета для вёб морды
  indexMajor: "#252525",
  indexMinor: "#363636",
  indexLogo: indexLogo,
  indexLogoText: indexLogoText,
  headerLogoText: indexLogoText,
  indexHeaderBackground: indexHeaderBackground,
  howToBg: howToBackground,

  // переменные хелпдеска
  helpdeskSeparator: "#676767",
  helpdeskMobileMenuSeparator: "#555555",
  helpdeskNavlinks: "#a7a7a7",
  // переменные для страницы /regbonus
  refHeader: "#252525",
  refLogo: refLogo,
  refLogoText: refLogoText,
  refFooterBorder: "#363636",
  refFooterColor: "#fff",
  refConditionBg: "#363636",
  refInvestmentBg: "#252525",

  // переменные статичных страниц
  staticHeaderLink: "#a7a7a7",

  toggleAccountLightBg: "#272B34",
  toggleAccountDarkBg: "#1D2027",

  popupBackground: "#1D2027",
  popupDarkBackground: "#272B34",

  desktopTourBg: desktopTourBgDark,
  minFontSize: "18px",
  textMuted: "#99959d",
  mainLink: "#0085eb",

  tradeHeaderAccent: "#feac00",
  dealsBackground: "#1D2027",
  dealIconColor: "#3B9478",
  barCaption: "#5D6067",
  cursorBarCaption: "#272B34",
  stockInfoBg: "#3D4149",

  tournamentPopupBgLight: "#272B34",
  tournamentPopupBgDark: "#1D2027",
  tournamentCardBg: "#1B546A",
  tournamentCardMainColor: "#ffffff",
  tournamentCardSecondaryColor: "#ffffff",
  tournamentCardPlaceholder: "#ffffff",

  scrollColor: "rgba(255, 255, 255, 0.5)",

  currencyColor: "#feac00",

  themeToggleActive: "#ffffff",
  bottomNavigationBg: "#3B9478",
  chartTimeOtcColor: "#1B546A",

  navigationBg: "#1D2027",
  navigationItemColor: "#919191",
  navigationItemIcon: rgba("#919191", 0.59),
  navigationItemActiveBg: "#272B34",
  navigationItemIconActive: "#cccccc",

  operationChequeqColor: "#99959d",
  operationChequeColor: "#d2d2d2",

  bellNewsLinkColor: "#0085eb",

  oneSignalHeaderBg: "#399177",

  languageBackground: "rgba(19, 56, 64, 0.9)",
  languageColor: "#ffffff",
  stockCloseTimeColor: "#feac00",
  languageArrowColor: rgba("#fff", 0.7),

  sightseeingBg: "linear-gradient(to bottom, #282c33 0%, #3d3f42 100%)",
  sightseeingTitle: "#fff",
  sightseeingIron: "#feac00",
  sightseeingLater: "rgba(255, 255, 255, 0.5)",
  sightSeeingImageShadow: "rgba(255, 255, 255, 0.2)",
  sightSeeingBgShadow: "transparent",
  sightseeingBigBg: "rgba(255, 255, 255, 0.1)",
  sightseeingSmallBg: "rgba(255, 255, 255, 0.05)",
  sightSeeingStartButtonBg: "#feac00",
  sightSeeingStartButtonColor: "#000",
  sightSeeingBorder: "#9b9b9b",
  dotColor: "rgba(255, 255, 255, 0.5)",
  dotActiveColor: "#fff",

  suggestingInputBg: rgba("#ffffff", 0.1),
  suggestingInputBgDisabled: rgba("#ffffff", 0.25),
  suggestingInputButtonSymbol: "#ffffff",
  suggestingInputButtonSymbolDisabled: rgba("#919191", 0.59),

  mobileSwitchStockBackground: "#3D4149",
  mobileSwitchStockArrow: "#ffffff",

  socialTradingButtonBg: "#5E5968",
  socialTradingButtonBgHover: "rgba(255, 255, 255, 0.1)",
  socialTradingButtonBgActive: "#3B9478",
  socialTradingHiddenLink: "#1592E6",
  socialTradingHiddenLinkHover: "#1592E6",
  socialTradingBg: "#272B34",
  socialTradingTableHeaderBg: "#1D2027",
  socialTradingSubtitleColor: "#919191",

  sellDealBg: "#3D4149",
  sellDealBorder: "#797979",
  sellDealProfitColor: "#ffffff",
  sellDealButtonColor: "#ffcc00",
  sellDealHistoryBg: "#3d4149",
  sellDealHistoryColor: "#ffcc00",
  sellDealHistoryProgress: "#5d6067",

  //compensations
  compensationInfoIcon: "#919191",
  compensationSuccessTitle: "#FFCC00",
  compensationRefillTitle: "#ffffff",
  compensationSubtitle: "#ffffff",
  compensationAmountOfDeals: "#ffcc00",
  compensationActionButton: "#feac00",

  freeBonusPopupFontColor: "#ffffff",
  freeBonusPopupHintColor: "#cccccc",
  freeBonusPopupArrowColor: "#ffcc00",
  freeBonusPopupPercentColor: "#ffcc00",

  navigationUserName: "#ffffff",
  navigationMoney: "#ffffff",
  navigationId: "#FFCC00",
  navigationCall: "#FFCC00",
  navigationBorder: "#4B4F57",

  tabsTournamentsCategoryTitle: "#ffffff",
  sightSeeingWithdrawTitle: "#FFCC00",

  tourWitdrawMethodHover: "#3b9478",

  suspiciousActivityPopupBg: "#272B34",
  suspiciousActivityPopupText: "#FFFFFF",
  suspiciousActivityPopupButton: "#FFFFFF",
  suspiciousActivityPopupButtonHoverColor: "#0085EB",
  suspiciousActivityPopupLink: "#FFCC00",

  authCurrencyCodeColor: "#1B546A",
};

export default basic;

// дополнительные темы забирают
// недостающие настройки и цвета
// из базовых

export const richblue = {
  ...basic,

  // основной цвет
  main: "#061424",
  mainDark: "#0A131E", // шапка
  mainLight: "#121B27", // сайдбар
  mainHighlight: "#162130",
  mainFontColor: "#38465d",
  mainSeparator: "#2D3244",
  secondaryTextColor: "#99959d",

  borderMainColor: "#2D3244",
  ticksBorderColor: "#2D3244",

  popupBackground: "#0A131E",
  popupDarkBackground: "#162130",
  tradeHeaderAccent: "#feac00",
};

export const light = {
  ...basic,
  compensationInfoIcon: "#BABABA",
  compensationSuccess: "#3B9478",
  compensationActionButton: "#0085eb",
  compensationSubtitle: "#1B546A",
  // основной цвет
  isIntlProjectLight: true,
  main: "#f9f9f9",
  mainDark: "#D4D4D4", // шапка
  mainLight: "#f5f5f5", // сайдбар
  mainHighlight: "#fff",
  mainFontColor: "#38465d",
  mainSeparator: "#D4D4D4",

  indexMajor: "#ffffff",

  mode: "light",
  foreground: "#1B546A",
  alternativeForeground: "#feac00",
  lightWhiteForeground: "#ffffff",
  background: "#ffffff",
  mainColorBackground: "#1B546A",
  secondaryColorBackground: "#399177",

  textMuted: rgba("#fff", 0.5),

  tradeHeaderGradientTop: "#1B546A",
  tradeHeaderGradientBottom: "#399177",

  ticksFontColor: "#484848",
  borderMainColor: "#D4D4D4",
  ticksBorderColor: "#D4D4D4",

  alternativeUpper: "#27c191",
  accent: "#1B546A",
  alternativeAccent: "#feac00",
  lightAccent: "#0085eb",
  lightWhiteAccent: "#ffffff",
  secondaryTextColor: "#ffffff",

  staticHeaderLink: rgba("#000", 0.5),

  popupBackground: "#ffffff",
  popupDarkBackground: "#f5f5f5",
  desktopTourBg: desktopTourBgLight,
  tradeHeaderAccent: "#feac00",
  dealsBackground: "#ffffff",
  dealIconColor: "#3B9478",
  scrollColor: "#3B9478",
  barCaption: "#d4d4d4",
  cursorBarCaption: "#ffffff",
  stockInfoBg: "#e4e4e4",

  toggleAccountLightBg: "#F5F5F5",
  toggleAccountDarkBg: "#ffffff",
  chartTimeOtcColor: "#ffffff",

  tournamentPopupBgLight: "#3B9478",
  tournamentPopupBgDark: "#1B546A",

  currencyColor: "#3B9478",

  themeToggleActive: "#3B9478",

  navigationBg: "#e4e4e4",
  navigationItemColor: "#417581",
  navigationItemIcon: rgba("#919191", 0.59),
  navigationItemActiveBg: "#ffffff",
  navigationItemIconActive: "#3B9478",

  operationChequeColor: "#484848",

  bellNewsLinkColor: "#0085eb",

  oneSignalHeaderBg: "#1b546a",

  languageBackground: "rgba(19, 56, 64, 0.9)",
  stockCloseTimeColor: "#3B9478",
  sightseeingBg: "#F6F6F6",
  sightseeingTitle: "#000",
  sightseeingIron: "#000",
  sightseeingLater: "#3B9478",
  sightSeeingImageShadow: "rgba(0, 0, 0, 0.2)",
  sightSeeingBgShadow: "rgba(0, 0, 0, 0.2)",
  sightseeingBigBg: "#fff",
  sightseeingSmallBg: "#fff",
  sightSeeingStartButtonBg:
    "linear-gradient(to left, #47c0c8 0%, #5D67C0 100%)",
  sightSeeingStartButtonColor: "#fff",
  sightSeeingBorder: "#c7d9d8",
  dotColor: "rgba(24, 20, 28, 0.5)",
  dotActiveColor: "#2c7671",

  suggestingInputBg: rgba("#000000", 0.15),
  suggestingInputBgDisabled: rgba("#000000", 0.3),
  suggestingInputButtonSymbol: rgba("#919191", 0.8),
  suggestingInputButtonSymbolDisabled: rgba("#919191", 0.2),
  mobileSwitchStockBackground: "#ffffff",
  mobileSwitchStockArrow: "#1B546A",

  sellDealBg: "#ffffff",
  sellDealBorder: "#d2d2d2",
  sellDealProfitColor: "#1B546A",
  sellDealButtonColor: "#0085EB",
  sellDealHistoryBg: "#E5E5E5",
  sellDealHistoryColor: "#0085EB",
  sellDealHistoryProgress: "#D4D4D4",

  compensationSuccessTitle: "#3B9478",
  compensationRefillTitle: "#3B9478",
  compensationAmountOfDeals: "#3B9478",

  freeBonusPopupFontColor: "#343434",
  freeBonusPopupHintColor: "#919191",
  freeBonusPopupArrowColor: "#0085EB",
  freeBonusPopupPercentColor: "#3B9478",

  navigationUserName: "#1B546A",
  navigationMoney: "#1B546A",
  navigationId: "#0085EB",
  navigationCall: "#0085EB",
  navigationBorder: "#D4D4D4",

  tabsTournamentsCategoryTitle: "#343434",
  sightSeeingWithdrawTitle: "#1B546A",

  suspiciousActivityPopupBg: "#ffffff",
  suspiciousActivityPopupText: "#272B34",
  suspiciousActivityPopupButton: "#0085EB",
  suspiciousActivityPopupLink: "#0085EB",
};

export const newIndex = {
  newIndex: true,

  // ...dark,
  mode: "light",
  logo: <ReLogo />,
  main: "#3B9478",
  mainHighlight: "#133840",
  mainDark: "#0F2E31",
  upper: "#3B9478",
  alternativeUpper: "#27c191",
  lower: "#D05353",
  accent: "#FFCC00",

  lightWhiteForeground: "#ffffff",

  indexMajor: "#1b546a",
  indexMinor: "#133840",
  staticHeaderLink: rgba("#fff", 0.7),
  inputColor: "#ffffff",

  mainGradientDark: "#1b546a",
  mainGradientLight: "#55c784",
  gradientLight: "#399177",
  mainText: "#fff",
  mainLink: "#0085eb",
  mainDarkText: "#222222",

  tradeHeaderAccent: "#feac00",
  scrollColor: "rgba(255, 255, 255, 0.5)",
  bellNewsLinkColor: "#0085eb",

  oneSignalHeaderBg: "#399177",

  languageBackground: "rgba(19, 56, 64, 0.9)",

  refFooterBorder: "#919191",
  refFooterColor: "#919191",
  refConditionBg: "#1b546a",

  navigationBg: "#1D2027",
  navigationItemColor: "#919191",
  navigationItemIcon: rgba("#919191", 0.59),
  navigationItemActiveBg: "#272B34",
  navigationItemIconActive: "#cccccc",

  navigationUserName: "#ffffff",
  navigationMoney: "#3B9478",
  navigationId: "#FFCC00",
  navigationCall: "#FFCC00",
  navigationBorder: "#4B4F57",
};

export const thProjectTrade = {
  ...basic,
  ...basicSiam,
  logo: <Logo />,
  logoImg: logo,
  logoImgMobile: logoMobile,
  indexLogo: indexLogo,
  indexLogoText: indexLogoText,
  headerLogoText: indexLogoText,
  refLogo: refLogo,
  refLogoText: refLogoText,
  indexHeaderBackground: indexHeaderBackground,
  howToBg: howToBackground,
  errorBg: errorBg,
  desktopTourBg: desktopTourBgDark,
};



// WEBPACK FOOTER //
// ./src/themes/irontrade/irontrade.js